import { mapPriceData } from 'connectors/price/Prices';
import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { BlogPaymentsQueryApi, BlogTransportsQueryApi } from 'graphql/generated';
import { useFormatPrice } from 'hooks/formatting/useFormatPrice';
import useTranslation from 'next-translate/useTranslation';
import { twJoin } from 'tailwind-merge';

type BlogFulfillmentListProps = {
    freeFulfillmentLimit: string | null | undefined;
    fulfillmentItems: BlogPaymentsQueryApi['payments'] | BlogTransportsQueryApi['transportsList'] | undefined;
};

export const BlogFulfillmentList: FC<BlogFulfillmentListProps> = ({ freeFulfillmentLimit, fulfillmentItems }) => {
    const { currencyCode } = useDomainConfig();
    const { formatPriceNumber, formatPriceObject } = useFormatPrice();
    const { t } = useTranslation();

    if (!freeFulfillmentLimit && (!fulfillmentItems || fulfillmentItems.length === 0)) {
        return null;
    }

    return (
        <ul className="gjs-fulfillment-list">
            {freeFulfillmentLimit && (
                <li key="free-fulfillment-limit" className="text-green">
                    <span>
                        {t('Order above {{ price }}', {
                            price: formatPriceNumber(parseFloat(freeFulfillmentLimit)),
                        })}
                    </span>
                    <span className="lowercase">{t('Free')}</span>
                </li>
            )}
            {fulfillmentItems?.map((fulfillment) => (
                <li
                    key={fulfillment.uuid}
                    className={twJoin(fulfillment.price.priceWithVat[0] === '0' && 'text-green')}
                >
                    <span>{fulfillment.name}</span>
                    <span
                        className={twJoin(
                            formatPriceObject(mapPriceData(fulfillment.price, currencyCode)) === t('Free') &&
                                'lowercase',
                        )}
                    >
                        {formatPriceObject(mapPriceData(fulfillment.price, currencyCode))}
                    </span>
                </li>
            ))}
        </ul>
    );
};
